import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { Outlet } from 'react-router-dom';
import { Suspense, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import DesktopTitledLayout from './desktop-layout';
import MobileLayout from './mobile-layout';
import Navvy from './navvy';

// Account area (account experience). Tabs surface existing components: My Details,
// Saved Addresses and Billing (the Invoices / Statements view). Underline tab style
// (Navvy), no counts. Stored Cards / API Keys / Tariff Codes are deferred.
const routes = [RoutingConstants.MyDetails, RoutingConstants.SavedAddresses, RoutingConstants.Billing];

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { t } = useTranslation(TranslationNamespaces.MYACCOUNT);

  const labels = useMemo(
    () => ({
      [RoutingConstants.MyDetails]: t('ACCOUNT_TAB_MY_DETAILS', { defaultValue: 'My Details' }),
      [RoutingConstants.SavedAddresses]: t('ACCOUNT_TAB_SAVED_ADDRESSES', { defaultValue: 'Saved Addresses' }),
      [RoutingConstants.Billing]: t('ACCOUNT_TAB_BILLING', { defaultValue: 'Billing' })
    }),
    [t]
  );

  if (isXs) {
    return (
      <MobileLayout>
        <Outlet />
      </MobileLayout>
    );
  }

  return (
    <DesktopTitledLayout title={t('ACCOUNT_AREA_TITLE', { defaultValue: 'Account' })}>
      <Suspense>
        <Navvy routes={routes} prefix="ACCOUNT" labels={labels} />
      </Suspense>
      <Outlet />
    </DesktopTitledLayout>
  );
}

Component.displayName = 'Account';
